// Product Modal - DISABLED - Modal system removed in favor of standard product page navigation
class ProductModal {
  constructor() {
    this.currentModal = null;
    this.isLoading = false;
    // this.init(); // DISABLED - Modal functionality disabled
    console.log('🔄 Product Modal system disabled - Using standard product page navigation');
  }

  init() {
    // DISABLED - Modal functionality removed
    // Product cards now use standard link navigation to product pages
    return;
    
    /*
    this.removeExistingListeners();
    
    // Card click events - DISABLED
    document.addEventListener('click', (e) => {
      const neoCard = e.target.closest('.neo-card');
      const addBtn = e.target.closest('.neo-card__add-btn');
      
      // Ignore add to cart button clicks
      if (addBtn) return;
      
      // Handle modal triggers - DISABLED
      if (neoCard && !this.shouldIgnoreClick(e.target)) {
        e.preventDefault();
        e.stopPropagation();
        
        const productId = neoCard.dataset.productId;
        const productUrl = neoCard.dataset.productUrl;
        
        if (productId && productUrl && !this.isLoading) {
          this.openModal(productId, productUrl);
        }
        return;
      }

      // Handle modal close
      if (e.target.matches('.product-modal__overlay') ||
          e.target.matches('.product-modal__close') ||
          e.target.closest('.product-modal__close')) {
        this.closeModal();
        return;
      }
    });

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.currentModal) {
        this.closeModal();
      }
    });
    */
  }

  removeExistingListeners() {
    const existingModals = document.querySelectorAll('.product-modal');
    existingModals.forEach(modal => modal.remove());
  }

  shouldIgnoreClick(element) {
    const ignoredSelectors = [
      'button', 'input', 'select', 'textarea', 
      'a[href]:not(.neo-card__title-link)', 
      '.btn', '.button', '.neo-card__add-btn',
      '.neo-card__cart-form', '.quantity__button',
      'form', '.neo-card__actions'
    ];
    
    return ignoredSelectors.some(selector => {
      return element.matches && element.matches(selector) || 
             element.closest && element.closest(selector);
    });
  }

  extractCardData(productCard) {
    if (!productCard) return null;

    const title = productCard.querySelector('.neo-card__title-link')?.textContent?.trim() || 'Product';
    const image = productCard.querySelector('.neo-card__image img')?.src || '';
    const currentPrice = productCard.querySelector('.neo-card__price-current')?.textContent?.trim() || '';
    const comparePrice = productCard.querySelector('.neo-card__price-compare')?.textContent?.trim() || '';
    const variantId = productCard.querySelector('.neo-card__variant-id')?.value || '';
    const productUrl = productCard.dataset.productUrl || '';

    return {
      title,
      image,
      currentPrice,
      comparePrice,
      variantId,
      productUrl
    };
  }

  async openModal(productId, productUrl) {
    if (this.isLoading) return;
    this.isLoading = true;

    try {
      this.removeExistingModal();

      const productCard = document.querySelector(`[data-product-id="${productId}"]`);
      const cardData = this.extractCardData(productCard);

      const modal = this.createModalWithData(productId, cardData);
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
      
      this.currentModal = modal;

      requestAnimationFrame(() => {
        modal.classList.add('active');
      });

      // Load detailed product data
      const response = await fetch(productUrl + '.js');
      if (!response.ok) {
        throw new Error(`Fetch failed: ${response.status}`);
      }
      
      const product = await response.json();
      
      // Update modal with detailed data
      this.updateModalWithDetailedData(modal, product);
      this.setupModalEvents(modal, product);

    } catch (error) {
      this.closeModal();
      window.location.href = productUrl;
    } finally {
      this.isLoading = false;
    }
  }

  createModalWithData(productId, cardData) {
    const modal = document.createElement('div');
    modal.className = 'product-modal';
    modal.id = `product-modal-${productId}`;
    
    modal.innerHTML = `
      <div class="product-modal__overlay"></div>
      <div class="product-modal__container">
        <div class="product-modal__header">
          <button class="product-modal__close" type="button" aria-label="Close">✕</button>
        </div>
        <div class="product-modal__content">
          <div class="product-modal__media">
            <div class="product-modal__gallery">
              <div class="product-modal__main-image">
                <img src="${cardData?.image || ''}" alt="${cardData?.title || 'Product'}" class="product-modal__image">
              </div>
            </div>
          </div>
          <div class="product-modal__info">
            <h1 class="product-modal__title">${cardData?.title || 'Product'}</h1>
            <div class="product-modal__price">
              <div class="product-modal__price-wrapper">
                <span class="price">${cardData?.currentPrice || ''}</span>
                ${cardData?.comparePrice ? `<span class="price__compare">${cardData.comparePrice}</span>` : ''}
              </div>
            </div>
            <div class="product-modal__actions">
              <div class="product-modal__quantity">
                <label class="form__label">Miktar</label>
                <div class="quantity">
                  <button type="button" class="quantity__minus">−</button>
                  <input type="number" class="quantity__input" value="1" min="1">
                  <button type="button" class="quantity__plus">+</button>
                </div>
              </div>
              <div class="product-modal__buttons">
                <button type="button" class="product-modal__add-to-cart">Sepete Ekle</button>
                <button type="button" class="product-modal__buy-now">Hemen Al</button>
              </div>
            </div>
            <div class="product-modal__footer">
              <a href="${cardData?.productUrl || '#'}" class="product-modal__view-details">
                Tüm Detayları Gör →
              </a>
            </div>
            <input type="hidden" id="selected-variant-${productId}" value="${cardData?.variantId || ''}">
          </div>
        </div>
      </div>
    `;

    return modal;
  }

  updateModalWithDetailedData(modal, product) {
    const hasVariants = product.variants.length > 1;
    const hasMedia = product.media && product.media.length > 0;

    // Update media section
    if (hasMedia) {
      const mediaSection = modal.querySelector('.product-modal__media');
      const mediaHTML = this.createMediaHTML(product);
      mediaSection.innerHTML = mediaHTML;
      
      // Initialize 3D viewer if available
      if (window.Custom3DViewer) {
        this.initialize3DModels(modal, product);
      }
    }

    // Add description
    if (product.description) {
      const priceSection = modal.querySelector('.product-modal__price');
      const descriptionHTML = `
        <div class="product-modal__description">
          ${product.description.length > 200 ? product.description.substring(0, 200) + '...' : product.description}
        </div>
      `;
      priceSection.insertAdjacentHTML('afterend', descriptionHTML);
    }

    // Add variants
    if (hasVariants) {
      const actionsSection = modal.querySelector('.product-modal__actions');
      const variantsHTML = this.createVariantHTML(product);
      actionsSection.insertAdjacentHTML('beforebegin', variantsHTML);
    }
  }

  createMediaHTML(product) {
    const featuredMedia = product.media.find(m => m.id === product.featured_media_id) || product.media[0];
    
    // Filter models - only show _dik.glb for display
    const displayMedia = product.media.filter((media) => {
      if (media.media_type === 'model') {
        const modelUrl = media.sources?.[0]?.url || '';
        return modelUrl.includes('_dik.glb');
      }
      return true;
    });
    
    return `
      <div class="product-modal__gallery">
        <div class="product-modal__main-image">
          ${this.createMainMediaHTML(featuredMedia, product)}
        </div>
        ${displayMedia.length > 1 ? `
          <div class="product-modal__thumbnails">
            ${displayMedia.slice(0, 6).map((media, i) => `
              <div class="product-modal__thumbnail ${media.id === featuredMedia.id ? 'active' : ''}" 
                   data-media-id="${media.id}" 
                   data-media-type="${media.media_type}">
                <img src="${this.getMediaThumbnail(media)}" alt="${media.alt || product.title}" loading="lazy">
                ${media.media_type === 'model' ? '<span class="product-modal__3d-badge">3D</span>' : ''}
                ${media.media_type === 'video' ? '<span class="product-modal__video-badge">▶</span>' : ''}
              </div>
            `).join('')}
          </div>
        ` : ''}
      </div>
    `;
  }

  createMainMediaHTML(media, product) {
    switch (media.media_type) {
      case 'model':
        return `
          <div class="product-modal__3d-viewer" 
               data-model-url="${media.sources[0].url}"
               data-alt="${media.alt || product.title}">
            <canvas class="product-modal__3d-canvas"></canvas>
            <div class="product-modal__3d-loading">
              <div class="loading-spinner">🎭 3D Model Yükleniyor...</div>
            </div>
          </div>
        `;
      case 'video':
        return `
          <video src="${media.sources[0].url}" poster="${media.preview_image?.src || ''}" 
                 controls class="product-modal__video">
          </video>
        `;
      default:
        return `
          <img src="${media.src || media.preview_image?.src}" 
               alt="${media.alt || product.title}" class="product-modal__image">
        `;
    }
  }

  getMediaThumbnail(media) {
    return media.media_type === 'image' ? media.src : media.preview_image?.src || media.src;
  }

  initialize3DModels(modal, product) {
    const viewers = modal.querySelectorAll('.product-modal__3d-viewer');
    viewers.forEach(viewer => {
      const modelUrl = viewer.dataset.modelUrl;
      if (modelUrl && window.Custom3DViewer) {
        new window.Custom3DViewer(viewer, modelUrl, product);
      }
    });
  }

  setupModalEvents(modal, product) {
    const productId = product.id;

    // Thumbnail clicks
    modal.querySelectorAll('.product-modal__thumbnail').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const mediaId = thumb.dataset.mediaId;
        const media = product.media.find(m => m.id == mediaId);
        
        if (media) {
          const mainImage = modal.querySelector('.product-modal__main-image');
          if (mainImage) {
            mainImage.innerHTML = this.createMainMediaHTML(media, product);
            
            if (media.media_type === 'model' && window.Custom3DViewer) {
              this.initialize3DModels(modal, product);
            }
          }
          
          modal.querySelectorAll('.product-modal__thumbnail').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        }
      });
    });

    // Quantity controls
    const quantityInput = modal.querySelector('.quantity__input');
    const minusBtn = modal.querySelector('.quantity__minus');
    const plusBtn = modal.querySelector('.quantity__plus');

    if (minusBtn && quantityInput) {
      minusBtn.addEventListener('click', () => {
        const value = parseInt(quantityInput.value) || 1;
        if (value > 1) quantityInput.value = value - 1;
      });
    }

    if (plusBtn && quantityInput) {
      plusBtn.addEventListener('click', () => {
        const value = parseInt(quantityInput.value) || 1;
        quantityInput.value = value + 1;
      });
    }

    // Variant selection
    modal.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        this.updateSelectedVariant(productId, product, modal);
        
        const label = radio.closest('.product-modal__option-value');
        if (label) {
          label.parentElement.querySelectorAll('.product-modal__option-value')
            .forEach(l => l.classList.remove('selected'));
          label.classList.add('selected');
        }
      });
    });

    // Cart actions
    const addToCartBtn = modal.querySelector('.product-modal__add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => this.addToCart(productId, modal));
    }

    const buyNowBtn = modal.querySelector('.product-modal__buy-now');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', () => this.buyNow(productId, modal));
    }
  }

  createVariantHTML(product) {
    if (!product.options || product.options.length === 0) return '';
    
    return `
      <div class="product-modal__variants">
        ${product.options.map((option, optionIndex) => `
          <div class="product-modal__option">
            <label class="product-modal__option-label">${option}</label>
            <div class="product-modal__option-values">
              ${this.getOptionValues(product, optionIndex).map((value, valueIndex) => `
                <label class="product-modal__option-value ${valueIndex === 0 ? 'selected' : ''}">
                  <input type="radio" name="option-${optionIndex}" value="${value}" ${valueIndex === 0 ? 'checked' : ''}>
                  <span>${value}</span>
                </label>
              `).join('')}
            </div>
          </div>
        `).join('')}
      </div>
    `;
  }

  getOptionValues(product, optionIndex) {
    const values = new Set();
    product.variants.forEach(variant => {
      if (variant.options && variant.options[optionIndex]) {
        values.add(variant.options[optionIndex]);
      }
    });
    return Array.from(values);
  }

  updateSelectedVariant(productId, product, modal) {
    const selectedOptions = [];
    modal.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
      selectedOptions.push(radio.value);
    });

    const matchingVariant = product.variants.find(variant => {
      return selectedOptions.every((option, index) => variant.options[index] === option);
    });

    if (matchingVariant) {
      const variantInput = modal.querySelector(`#selected-variant-${productId}`);
      if (variantInput) variantInput.value = matchingVariant.id;
      
      // Update price
      const priceElement = modal.querySelector('.price');
      if (priceElement) priceElement.textContent = this.formatPrice(matchingVariant.price);
      
      const comparePriceElement = modal.querySelector('.price__compare');
      if (comparePriceElement) {
        if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
          comparePriceElement.textContent = this.formatPrice(matchingVariant.compare_at_price);
          comparePriceElement.style.display = 'inline';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }
    }
  }

  async addToCart(productId, modal) {
    const button = modal.querySelector('.product-modal__add-to-cart');
    const variantInput = modal.querySelector(`#selected-variant-${productId}`);
    const quantityInput = modal.querySelector('.quantity__input');
    
    if (!button || !variantInput || !quantityInput) {
      return;
    }

    const variantId = variantInput.value;
    const quantity = parseInt(quantityInput.value) || 1;
    const originalText = button.textContent;


    // Set loading state
    button.textContent = 'Ekleniyor...';
    button.disabled = true;
    button.classList.add('loading');

    try {
      // Create FormData for better compatibility
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);


      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const result = await response.json();

      if (response.ok && result) {
        
        // Success feedback
        button.textContent = 'Eklendi! ✓';
        button.classList.remove('loading');
        button.classList.add('success');
        
        // CRITICAL: Update cart system
        await this.updateCartCount();
        
        // Success animation
        modal.style.transform = 'scale(1.02)';
        setTimeout(() => {
          modal.style.transform = '';
        }, 200);
        
        // Reset button state
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          button.classList.remove('success');
        }, 2000);

      } else {
        throw new Error(result?.message || result?.description || 'Failed to add to cart');
      }
    } catch (error) {
      
      // Error feedback
      button.textContent = 'Hata! Tekrar dene';
      button.classList.remove('loading');
      button.classList.add('error');
      
      // Error animation
      modal.style.animation = 'shake 0.5s ease-in-out';
      setTimeout(() => {
        modal.style.animation = '';
      }, 500);
      
      // Reset button state
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        button.classList.remove('error');
      }, 3000);
    }
  }

  async buyNow(productId, modal) {
    const variantInput = modal.querySelector(`#selected-variant-${productId}`);
    const quantityInput = modal.querySelector('.quantity__input');
    
    if (!variantInput || !quantityInput) return;

    const variantId = variantInput.value;
    const quantity = parseInt(quantityInput.value) || 1;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      window.location.href = '/checkout';
    } catch (error) {
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update all cart count displays
      document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(element => {
        element.textContent = cart.item_count;
        if (cart.item_count > 0) {
          element.style.display = 'block';
        }
      });

      // Update header cart counts specifically
      const cartCount = document.querySelector('.cart-count');
      const bottomCartCount = document.querySelector('.bottom-nav-count');
      
      if (cartCount) {
        if (cart.item_count > 0) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = 'flex';
        } else {
          cartCount.style.display = 'none';
        }
      }
      
      if (bottomCartCount) {
        if (cart.item_count > 0) {
          bottomCartCount.textContent = cart.item_count;
          bottomCartCount.style.display = 'flex';
        } else {
          bottomCartCount.style.display = 'none';
        }
      }

      // CRITICAL: Refresh cart dropdown to show added items
      if (window.simpleHeader) {
        setTimeout(() => {
          window.simpleHeader.refreshCartDropdown();
          window.simpleHeader.animateCartCount();
        }, 100);
      }

      // Trigger PubSub event for consistency 
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-modal',
          cartData: cart
        });
      }

    } catch (error) {
    }
  }

  formatPrice(price) {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    }).format(price / 100);
  }

  closeModal() {
    if (this.currentModal) {
      this.currentModal.classList.remove('active');
      document.body.style.overflow = '';
      
      setTimeout(() => {
        if (this.currentModal) {
          this.currentModal.remove();
          this.currentModal = null;
        }
      }, 300);
    }
  }

  removeExistingModal() {
    const existingModal = document.querySelector('.product-modal');
    if (existingModal) {
      existingModal.remove();
    }
  }
}

// Initialize when DOM is ready - DISABLED
document.addEventListener('DOMContentLoaded', function() {
  // window.productModal = new ProductModal(); // DISABLED
  console.log('✅ Product Modal system disabled - Cards now use direct product page navigation');
});
